// extracted by mini-css-extract-plugin
export default {"table":"Table_table__6sIvw","th":"Table_th__YFFyS","first-col":"Table_first-col__zSo48","row":"Table_row__jDhf-"};